<div class="conteudo">
  <app-loading [exibir]="carregando"></app-loading>
  <div class="container-fluid cartoes">
    <div class="row faixa-conteudo pt0">

      <!-- Periodo Sem Borda -->
      <!-- <div class="col col-lg-10">
        <div class="row periodo-dash ml-1">
          <div translate>
            {{'home.referentePeriodo'}}
          </div>
          <div class="ml-2">
            {{dados?.periodo?.inicio | date:'dd/MM/yyyy'}} - {{dados?.periodo?.fim | date:'dd/MM/yyyy'}}
          </div>
          <div class="clear"></div>
        </div>
      </div>
      <div class="botao col col-lg-2">
        <button translate class="btn btn-info btn-sm float-right" (click)="atualizarFiltroMarcas()">
          <em class="fa fa-sync-alt"></em>
        </button>
      </div> -->

      <!-- Periodo Com Borda -->
      <!-- <div class="col col-lg-12">
        <div class="caixa">
          <div class="conteudo-caixa-sem-titulo sem-padding">
            <div class="filtro-dash">
              <div class="botaoSync">
                <button translate class="btn btn-info btn-sm float-right" (click)="atualizarFiltroMarcas()">
                  <em class="fa fa-sync-alt"></em>
                </button>
              </div>
              <div class="col col-lg-10">
                <div class="row periodo-dash ml-1">
                  <div translate>
                    {{'home.referentePeriodo'}}
                  </div>
                  <div class="row ml-2">
                    {{dados?.periodo?.inicio | date:'dd/MM/yyyy'}} - {{dados?.periodo?.fim | date:'dd/MM/yyyy'}}
                  </div>
                  <div class="clear"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <!-- Filtro Marca -->
      <div class="col col-lg-12">

        <div class="p-message p-message-error pulse-msg-button" *ngIf="dealersInativos == true"
          (click)="goToStatusServico()" pTooltip="{{'home.botaoAlertaDealers.visualizarDealersInativos' | translate}}"
          tooltipPosition="top">
          <div class="p-message-wrapper">
            <span translate class="p-message-summary">{{'home.botaoAlertaDealers.atencao'}}</span>
            <span translate class="p-message-detail">{{'home.botaoAlertaDealers.mensagemInativos'}}</span>
          </div>
        </div>

        <div class="caixa">
          <div class="conteudo-caixa-sem-titulo sem-padding">
            <div class="filtro-dash">
              <div class="filtro" *ngFor="let marca of filtroMarcas">
                <label [for]="'checkbox' + marca.id" class="btn btn-outline-info btn-sm"
                  *ngIf="marca.selecionado == true">
                  <input [id]="'checkbox' + marca.id" type="checkbox" [checked]="marca.selecionado"
                    (click)="marcar(marca)" />
                  <em class="marcado fa fa-check"></em>
                  {{marca.descricao}}
                </label>
                <label [for]="'checkbox' + marca.id" class="btn btn-outline-info btn-sm"
                  *ngIf="marca.selecionado == false">
                  <input [id]="'checkbox' + marca.id" type="checkbox" [checked]="marca.selecionado"
                    (click)="marcar(marca)" />
                  <em class="desmarcado far fa-square"></em>
                  {{marca.descricao}}
                </label>
              </div>
              <div class="botao">
                <button translate class="btn btn-info btn-sm" (click)="atualizarFiltroMarcas()">
                  <em class="fa fa-search"></em> {{'home.buscar'}}
                </button>
              </div>
              <div class="clear"></div>
            </div>
          </div>
        </div>
        <div class="row periodo-dash ml-2">
          <div translate>
            {{'home.referentePeriodo'}}
          </div>
          <div class="ml-2">
            {{dados?.periodo?.inicio | date:'dd/MM/yyyy'}} - {{dados?.periodo?.fim | date:'dd/MM/yyyy'}}
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col col-lg-3">
        <div class="cartao pecas shadow">
          <div translate class="caption">{{'home.pecas'}}</div>
          <div class="valor">
            {{ getAnimatedValue('valorPecas') }}
          </div>
          <div class="caption-bottom">
            <ngx-odometer [number]="dados.percentual_pecas" [config]="configShowNumber"></ngx-odometer>%
          </div>
        </div>
      </div>
      <div class="col col-lg-3">
        <div class="cartao sucesso shadow">
          <div translate class="caption">{{'home.maoObra'}}</div>
          <div class="valor">
            {{ getAnimatedValue('valorMaoObra') }}
          </div>
          <div class="caption-bottom">
            <ngx-odometer [number]="dados.percentual_mao_obra" [config]="configShowNumber"></ngx-odometer>%
          </div>
        </div>
      </div>
      <div class="col col-lg-3">
        <div class="cartao acessorios shadow">
          <div translate class="caption">{{'home.acessorios'}}</div>
          <div class="valor">
            {{ getAnimatedValue('valorAcessorios') }}
          </div>
          <div class="caption-bottom">
            <ngx-odometer [number]="dados.percentual_acessorios" [config]="configShowNumber"></ngx-odometer>%
          </div>
        </div>
      </div>
      <div class="col col-lg-3">
        <div class="cartao shadow">
          <div class="caption">Total</div>
          <div class="valor">
            {{ getAnimatedValue('valor_os_fechada') }}
          </div>
        </div>
      </div>
    </div>
    <div class="row faixa-conteudo">

      <div class="col col-lg-12">
        <div class="caixa h-100 borda-caixa shadow">
          <div translate class="text-center titulo">{{'home.osParadaAbertaDezDias'}}</div>
          <div class="conteudo-caixa p0">
            <div class="dados-valor-kpi">
              <div class="row pl-3 pr-3">
                <div class="cor dado col-md col-sm">
                  <span *ngIf="pulseButton" (click)="goToVor()" pTooltip="{{'home.visualizarOsParada' | translate}}"
                    [ngClass]="'pulse-button'">
                    <i class="fas fa-exclamation-triangle"></i>
                  </span>
                  <span *ngIf="!pulseButton" class="icone">
                    <i class="fas fa-clipboard"></i>
                  </span>
                  <div translate class="texto">
                    <span class="quatidade quantidade">
                      <ngx-odometer [number]="this.data" [config]="configShowNumber"></ngx-odometer>
                    </span>
                    {{'home.quantidade'}}
                  </div>
                </div>
                <div class="cor2 dado col-md col-sm">
                  <div class="icone">
                    <em class="fas fa-dollar-sign"></em>
                  </div>
                  <div translate class="texto">
                    <span class="quatidade">
                      {{ getAnimatedValue('valueOsStopped') }}
                    </span>
                    {{'home.valor'}}
                  </div>
                  <div class="clear"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col col-lg-4">
        <div class="caixa h-100 borda-caixa shadow">
          <div translate class="text-center titulo">{{'home.osAberta'}}</div>
          <div class="conteudo-caixa p0">
            <div class="dados-valor-kpi">
              <div class="dado">
                <div class="icone">
                  <em class="fas fa-clipboard-list"></em>
                </div>
                <div translate class="texto">
                  <span class="quatidade">
                    <ngx-odometer [number]="dados.quantidade_os_aberta" [config]="configShowNumber"></ngx-odometer>
                  </span>
                  {{'home.quantidade'}}
                </div>
                <div class="clear"></div>
              </div>
              <div class="dado cor2">
                <div class="icone">
                  <em class="fas fa-dollar-sign"></em>
                </div>
                                  <div translate class="texto">
                    <span class="quatidade">
                      {{ getAnimatedValue('valor_os_aberta') }}
                    </span>
                    {{'home.valor'}}
                  </div>
                <div class="clear"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col col-lg-4">
        <div class="caixa h-100 borda-caixa shadow">
          <div translate class="text-center titulo">{{'home.osFechada'}}</div>
          <div class="conteudo-caixa p0">
            <div class="dados-valor-kpi">
              <div class="dado">
                <div class="icone">
                  <em class="fas fa-clipboard-check"></em>
                </div>
                <div translate class="texto">
                  <span class="quatidade">
                    <ngx-odometer [number]="dados.quantidade_os_fechada" [config]="configShowNumber"></ngx-odometer>
                  </span>
                  {{'home.quantidade'}}
                </div>
                <div class="clear"></div>
              </div>
              <div class="dado cor2">
                <div class="icone">
                  <em class="fas fa-dollar-sign"></em>
                </div>
                                  <div translate class="texto">
                    <span class="quatidade">
                      {{ getAnimatedValue('valor_os_fechada') }}
                    </span>
                    {{'home.valor'}}
                  </div>
                <div class="clear"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col col-lg-4">
        <div class="caixa h-100 borda-caixa shadow">
          <div translate class="text-center titulo">{{'home.total'}}</div>
          <div class="conteudo-caixa-chartPie">
            <canvas baseChart #chartValores="base-chart" [colors]="[{}]" [datasets]="chartValoresData"
              [labels]="chartValoresLabels" [options]="chartValoresOptions" [chartType]="chartValoresType"
              [legend]="chartValoresLegend"
              class="mt-3"></canvas>
          </div>
        </div>
      </div>
      <div class="col col-lg-6">
        <div class="caixa borda-caixa shadow">
          <div translate class="text-center titulo">{{'home.aberturasOrdensServiço'}}</div>
          <div class="conteudo-caixa">
            <nav class="topo-abas">
              <div class="nav nav-tabs" role="tablist">
                <a translate id="quantidade-aberta-tab" href="#quantidade-aberta" aria-controls="quantidade-aberta"
                  aria-selected="true" class="nav-item nav-link active" data-toggle="tab" role="tab">
                  {{'home.quantidade'}}
                </a>
                <a translate id="valor-aberta-tab" href="#valor-aberta" aria-controls="valor-aberta"
                  aria-selected="true" class="nav-item nav-link" data-toggle="tab" role="tab">
                  {{'home.valor'}}
                </a>
              </div>
            </nav>
            <div class="tab-content" id="nav-tabContent">
              <div id="quantidade-aberta" aria-labelledby="quantidade-aberta-tab"
                class="grafico tab-pane fade show active pt10" role="tabpanel">
                <canvas baseChart #chartQuantidadeAberturaOS="base-chart" [datasets]="chartQuantidadeAberturaOSData"
                  [labels]="chartQuantidadeAberturaOSLabels" [options]="chartQuantidadeAberturaOSOptions"
                  [chartType]="chartQuantidadeAberturaOSType" [legend]="chartQuantidadeAberturaOSLegend"
                  [plugins]="chartQuantidadeAberturaOSPlugins" (chartHover)="chartQuantidadeAberturaOSHovered"
                  (chartClick)="chartQuantidadeAberturaOSClicked"></canvas>
              </div>
              <div id="valor-aberta" aria-labelledby="valor-aberta-tab" class="grafico tab-pane fade show pt10"
                role="tabpanel">
                <canvas baseChart #chartValorAberturaOS="base-chart" [datasets]="chartValorAberturaOSData"
                  [labels]="chartValorAberturaOSLabels" [options]="chartValorAberturaOSOptions"
                  [chartType]="chartValorAberturaOSType" [legend]="chartValorAberturaOSLegend"
                  [plugins]="chartValorAberturaOSPlugins" (chartHover)="chartValorAberturaOSHovered"
                  (chartClick)="chartValorAberturaOSClicked"></canvas>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col col-lg-6">
        <div class="caixa borda-caixa shadow">
          <div translate class="text-center titulo"> {{'home.fechamentosOrdensServiço'}} </div>
          <div class="conteudo-caixa">
            <nav class="topo-abas">
              <div class="nav nav-tabs" role="tablist">
                <a translate id="quantidade-fechada-tab" href="#quantidade-fechada" aria-controls="quantidade-fechada"
                  aria-selected="true" class="nav-item nav-link active" data-toggle="tab" role="tab">
                  {{'home.quantidade'}}
                </a>
                <a translate id="valor-fechada-tab" href="#valor-fechada" aria-controls="valor-fechada"
                  aria-selected="true" class="nav-item nav-link" data-toggle="tab" role="tab">
                  {{'home.valor'}}
                </a>
              </div>
            </nav>
            <div class="tab-content" id="nav-tabContent">
              <div id="quantidade-fechada" aria-labelledby="quantidade-fechada-tab"
                class="grafico tab-pane fade show active pt10" role="tabpanel">
                <canvas baseChart #chartQuantidadeFechamentoOS="base-chart" [datasets]="chartQuantidadeFechamentoOSData"
                  [labels]="chartQuantidadeFechamentoOSLabels" [options]="chartQuantidadeFechamentoOSOptions"
                  [chartType]="chartQuantidadeFechamentoOSType" [legend]="chartQuantidadeFechamentoOSLegend"
                  [plugins]="chartQuantidadeFechamentoOSPlugins" (chartHover)="chartQuantidadeFechamentoOSHovered"
                  (chartClick)="chartQuantidadeFechamentoOSClicked"></canvas>
              </div>
              <div id="valor-fechada" aria-labelledby="valor-fechada-tab" class="grafico tab-pane fade show pt10"
                role="tabpanel">
                <canvas baseChart #chartValorFechamentoOS="base-chart" [datasets]="chartValorFechamentoOSData"
                  [labels]="chartValorFechamentoOSLabels" [options]="chartValorFechamentoOSOptions"
                  [chartType]="chartValorFechamentoOSType" [legend]="chartValorFechamentoOSLegend"
                  [plugins]="chartValorFechamentoOSPlugins" (chartHover)="chartValorFechamentoOSHovered"
                  (chartClick)="chartValorFechamentoOSClicked"></canvas>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="row faixa-conteudo">
     
    </div> -->
  </div>
</div>